import Vue from 'vue';
import PxCriterioProjeto from '@/modules/alcadas/components/criterios/PxCriterioProjeto.vue';
import PxCriterioCentroCusto from '@/modules/alcadas/components/criterios/PxCriterioCentroCusto.vue';
import PxCriterioProduto from '@/modules/alcadas/components/criterios/PxCriterioProduto.vue';
import PxCriterioUrgencia from '@/modules/alcadas/components/criterios/PxCriterioUrgencia.vue';
import PxCriterioCategoria from '@/modules/alcadas/components/criterios/PxCriterioCategoria.vue';
import PxCriterioUsuario from '@/modules/alcadas/components/criterios/PxCriterioUsuario.vue';

Vue.component('PxCriterioProjeto', PxCriterioProjeto);
Vue.component('PxCriterioCentroCusto', PxCriterioCentroCusto);
Vue.component('PxCriterioProduto', PxCriterioProduto);
Vue.component('PxCriterioUrgencia', PxCriterioUrgencia);
Vue.component('PxCriterioCategoria', PxCriterioCategoria);
Vue.component('PxCriterioUsuario', PxCriterioUsuario);
